
import { makeApiRequest } from './apiService';
import { api } from './auth';

export const addOrganizationalOwnershipInfo = async (data) => {
  try {
    const response = await api.post('/organizationalOwnershipInfo/add', data);
    return response.data;
  } catch (error) {
    console.error('Error adding organizational ownership info:', error);
    throw error;
  }
};


export const getOrganizationalOwnershipInfoByOrgId = async (organizational_info_id) => {
  try {
    const response = await api.get(`/organizationalOwnershipInfo/${organizational_info_id}/get`);
    return response.data;
  } catch (error) {
    console.error('Error fetching organizational ownership info:', error);
    throw error;
  }
};

export const updateOrganizationalOwnershipInfo = async (data) => {
  try {
    const response = await api.post('/organizationalOwnershipInfo/update', data);
    return response.data;
  } catch (error) {
    console.error('Error updating organizational ownership info:', error);
    throw error;
  }
};

// Fetch User Profile
export const fetchUserProfile = async (userId) => {
  try {
    const response = await api.get(`/user/${userId}/getProfile`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};

// Fetch Personal Info
export const fetchPersonalInfo = async (userId) => {
  try {
    const response = await api.get(`/personalInfo/${userId}/get`);
    return response.data;
  } catch (error) {
    // If the data doesn't exist, return null
    if (error.response && error.response.status === 404) {
      return null;
    }
    throw error.response ? error.response.data : error.message;
  }
};

// Add or Update Personal Info
export const savePersonalInfo = async (userId, data) => {
  try {
    const existingData = await fetchPersonalInfo(userId); // Fetch existing data
    if (existingData) {
      // Update existing data
      const response = await api.post(`/personalInfo/update`, data);
      return response.data;
    } else {
      // Add new data
      const response = await api.post(`/personalInfo/add`, data);
      return response.data;
    }
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};

// Fetch Financial Info
export const fetchFinancialInfo = async (userId) => {
  try {
    const response = await api.get(`/financialInfo/${userId}/get`);
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      return null;
    }
    throw error.response ? error.response.data : error.message;
  }
};

// Add or Update Financial Info
export const saveFinancialInfo = async (userId, data) => {
  try {
    const existingData = await fetchFinancialInfo(userId);
    if (existingData) {
      const response = await api.post(`/financialInfo/update`, data);
      return response.data;
    } else {
      const response = await api.post(`/financialInfo/add`, data);
      return response.data;
    }
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};

// Fetch Account Info
export const fetchAccountInfo = async (userId) => {
  try {
    const response = await api.get(`/accountInfo/${userId}/get`);
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      return null;
    }
    throw error.response ? error.response.data : error.message;
  }
};

// Add or Update Account Info
export const saveAccountInfo = async (userId, data) => {
  try {
    const existingData = await fetchAccountInfo(userId);
    if (existingData) {
      const response = await api.post(`/accountInfo/update`, data);
      return response.data;
    } else {
      const response = await api.post(`/accountInfo/add`, data);
      return response.data;
    }
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};

// Fetch Organizational Info
export const fetchOrganizationalInfo = async (userId) => {
  try {
    const response = await api.get(`/organizationalInfo/${userId}/get`);
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      // Do not throw error, return null silently on 404
      return null;
    }
    throw error.response ? error.response.data : error.message;
  }
};

// Add or Update Organizational Info
export const saveOrganizationalInfo = async (userId, data) => {
  try {
    const existingData = await fetchOrganizationalInfo(userId);
    if (existingData) {
      const response = await api.post(`/organizationalInfo/update`, data);
      return response.data;
    } else {
      const response = await api.post(`/organizationalInfo/add`, data);
      return response.data;
    }
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};

// Fetch Organizational Financial Info
export const fetchOrgFinancialInfo = async (userId) => {
  try {
    const response = await api.get(`/orgFinancialInfo/${userId}/get`);
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      return null;
    }
    throw error.response ? error.response.data : error.message;
  }
};

// Add or Update Organizational Financial Info
export const saveOrgFinancialInfo = async (userId, data) => {
  try {
    const existingData = await fetchOrgFinancialInfo(userId);
    if (existingData) {
      const response = await api.post(`/orgFinancialInfo/update`, data);
      return response.data;
    } else {
      const response = await api.post(`/orgFinancialInfo/add`, data);
      return response.data;
    }
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};

export const addTradingAccount = async (tradingAccountData) => {
  try {
    const response = await api.post('/tradingAccount/add', tradingAccountData);
    if (response.status === 201) {
   //   console.log('Trading account added successfully');
      return response.data; // Return the response data for further use
    } else {
//console.error('Failed to add trading account:', response);
      throw new Error('Failed to add trading account');
    }
  } catch (error) {
    console.error('Error adding trading account:', error);
    throw error;
  }
};

// Add Wallet
export const addWallet = async (walletData) => {
  try {
    const response = await api.post('/wallet/add', walletData);
    if (response.status === 201) {
     // console.log('Wallet added successfully');
      return response.data; // Return the response data for further use
    } else {
    //  console.error('Failed to add wallet:', response);
      throw new Error('Failed to add wallet');
    }
  } catch (error) {
  //  console.error('Error adding wallet:', error);
    throw error;
  }
};

// Add Account Financial
export const addAccountFinancial = async (accountFinancialData) => {
  try {
    const response = await api.post('/accountFinancial/add', accountFinancialData);
    if (response.status === 201) {
  //    console.log('Account financial added successfully');
      return response.data; // Return the response data for further use
    } else {
 //     console.error('Failed to add account financial:', response);
      throw new Error('Failed to add account financial');
    }
  } catch (error) {
 //   console.error('Error adding account financial:', error);
    throw error;
  }
};

// Add Recent Activity
export const addRecentActivity = async (activityDetails) => {
  try {
    const response = await api.post('/recentActivity/add', activityDetails);
    if (response.status === 201) {
  //    console.log('Recent activity added successfully');
    } else {
   //   console.error('Failed to add recent activity:', response);
    }
  } catch (error) {
  //  console.error('Error adding recent activity:', error);
  }
};

// Upload Documents
export const uploadDocuments = async (userId) => {
  try {
    const response = await api.post('/fetchAndUploadDoc', { userId });
    if (response.status === 200) {
    //  console.log('Documents uploaded successfully');

    } else {
  //    console.error('Failed to upload documents:', response);
    }
  } catch (error) {
   throw error.response ? error.response.data : error.message;
   // console.error('Error uploading documents:', error);
  }
};
export const addDemoAccount = async (demoAccountData,) => {
  try {
    const response = await api.post('/tradingAccount/add', demoAccountData);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};

export const addDemoAccountFinancial = async (data) => {
  try {
    const response = await api.post('/accountFinancial/add', data);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};
export const addDemoAccountnoUser = async (demoAccountData,) => {
  try {
    const response = await api.post('/demoAccount/add', demoAccountData);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};
export const addDemoAccountFinancialnoUser = async (data) => {
  try {
    const response = await api.post('/demoAccountFinancial/add', data);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};

export const sendnewRealAccountReq = async (data) => {
  try {
    const response = await api.post('tradingAccount/new_trading_acc_req', data);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};
export const fetchAllAccountManagers = async () => {
  try {
    const response = await api.get('/accountManagers/getAll');
    return response.data;
  } catch (error) {
    // Handle 404 specifically if needed
    if (error.response && error.response.status === 404) {
      return null;
    }
    throw error.response ? error.response.data : error.message;
  }
};
// In your profile.js (API service file)
export const fetchUserDocuments = async (userId, accessToken) => {
  try {
    const response = await makeApiRequest(
      `/fetchAndUploadDoc/${userId}/get`,
      accessToken,
      'GET'
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};

export const downloadDocument = async (documentUrl, accessToken) => {
  try {
    // For S3 direct downloads, we don't need the API - we'll download directly
    // But we might need the token for authenticated downloads
    const response = await fetch(documentUrl,);
    return await response.blob();
  } catch (error) {
    throw error.message || 'Failed to download document';
  }
};
export const updateUserPassword = async (id, currentPassword, newPassword) => {
  try {
    const response = await api.post('/user/change_password', {
      id,
      currentPassword,
      newPassword
    });
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};

export const updateUserProfile = async (id, data) => {
  try {
    const payload = data ?? {};
    const response = await api.post(`/user/${id}/update`, payload);
    return response.data;
  } catch (error) {
    // keep error consistent with existing helpers
    throw error.response?.data?.message || error.response?.data || error.message;
  }
};

// Update User Current Step
export const updateUserCurrentStep = async (userId, currentStep) => {
  try {
    const response = await api.post(`/user/${userId}/update`, { current_step: currentStep });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};

// Create Support Ticket
export const createSupportTicket = async (ticketData) => {
  try {
    const response = await api.post('/tickets', ticketData);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};
// Request to become a partner (Introducer/Broker)
export const requestToBecomePartner = async (userId, country) => {
  try {
    const response = await api.post('/introducerBroker/new_ib_acc_req', {
      user_id: userId,
      country: country
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};
export const fetchDocRequests = async (userId, accessToken) => {
  try {
    const response = await makeApiRequest(
      `/fetchAndUploadDoc/get_doc_req/${userId}`,
      accessToken,
      'GET'
    );
    return response.data.doc_request || [];
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};

// Upload document file for a specific request ID
export const uploadDocumentFile = async (file, userId, accessToken) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('userId', userId);

    const response = await api.post('/fetchAndUploadDoc/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${accessToken}`,
      },
   
    });

    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};

// Update document request status to 'fulfil' by request ID
export const updateDocRequestStatus = async (requestId, userId) => {
  try {
    const response = await api.patch(`/fetchAndUploadDoc/update_doc_req/${requestId}`, {
      status: 'fulfilled',
      userId:userId
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};

// Upload signed document for a specific document request ID
export const uploadSignedDocument = async (requestId, formData, accessToken) => {
  try {
    const response = await api.post(`/fetchAndUploadDoc/doc_req/${requestId}/sign`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};
// api/profile.js (updated upload function)
export const uploadKYBDocuments = async (userId, files, accessToken) => {
  try {
    const formData = new FormData();
    formData.append('userId', userId);
    
    // Add files one by one with metadata
    files.forEach((file) => {
      formData.append('files', file, file.name); // Include filename
    });

    const response = await api.post('/orgInfoDoc/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${accessToken}`,
      },
      maxBodyLength: 50 * 1024 * 1024, // 50MB axios limit
      maxContentLength: 50 * 1024 * 1024,
    });
    
    return response.data;
  } catch (error) {
    // Improve error handling for 413
    if (error.response && error.response.status === 413) {
      throw new Error(`File upload failed: Server rejected large files (max ${process.env.MAX_FILE_SIZE_MB || 50}MB)`);
    }
    throw error.response ? error.response.data : error.message;
  }
};

// New API function to create access tokens and send links
export const createAccessTokensAndSendLinks = async (userId) => {
  try {
    const response = await api.post('/orgInfoDoc/createAccessTokensAndSendLinks', { userId });
    return response.data;
  } catch (error) {
    console.error('Error creating access tokens and sending links:', error);
    throw error;
  }
};

